<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('claim_type')">
            <a :href="urlGenerator('/hotel/claim')" class="btn btn-success mr-2">
                <app-icon class="size-20 mr-2" name="arrow-left"/>
                {{ $t('back') }}
            </a>
            <app-default-button
                :title="$fieldTitle('add', 'claim_type', true)"
                v-if="$can('create_hotel_claim_type')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="hotel-claim-type-table"
            :options="options"
            @action="triggerActions"
        />

        <app-hotel-claim-type-modal
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('hotel-claim-type-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import HotelClaimTypeMixins from "../../../Mixins/HotelClaimTypeMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "AppHotelClaimType",
    mixins: [HelperMixin, HotelClaimTypeMixins, TENANT_BASE_URL],
    data() {
        return {
            isModalActive: false,
            selectedUrl  : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/hotel/claim-type/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>